import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayButton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 17,
	viewBox: "0 0 18 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1422_5947)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M8.54343 14.8701C12.0629 14.8701 14.916 12.017 14.916 8.49753C14.916 4.97808 12.0629 2.125 8.54343 2.125C5.02398 2.125 2.1709 4.97808 2.1709 8.49753C2.1709 12.017 5.02398 14.8701 8.54343 14.8701Z",
			stroke: "#177400",
			strokeWidth: 1.06209,
			strokeMiterlimit: 10
		}), /* @__PURE__ */ _jsx("path", {
			d: "M10.6672 8.49527L7.48096 6.37109V10.6194L10.6672 8.49527Z",
			stroke: "#177400",
			strokeWidth: 1.06209,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1422_5947",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16.9934,
			height: 16.9934,
			fill: "white",
			transform: "translate(0.046875)"
		})
	}) })]
});
export default SvgPlayButton;
